<template>
  <div class="application_record">
    <div class="list">
      <div
        class="list_item"
        v-for="item in recordList"
        :key="item.id"
        @click="recordDetail(item.id)"
      >
        <div class="title">
          {{ item.serviceName }}<span>{{ item.fullName }}</span>
        </div>
        <div class="footer">
          申请时间: {{ item.createTime | getDate('YYYY-MM-DD HH:mm:ss') }}
          <div class="right" v-if="item.applyStatus === '1'">
            <span></span><span>确认中</span>
          </div>
          <div class="right pass" v-if="item.applyStatus === '2'">
            <span></span><span>通过</span>
          </div>
          <div class="right no_pass" v-if="item.applyStatus === '3'">
            <span></span><span>不通过</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getApplyRecored } from "@/api/service.js";
export default {
  name: "ApplicationRecord",
  data() {
    return {
      recordList: []
    };
  },
  methods: {
    recordDetail(id) {
      this.$router.push({ name: "recordDetail", query: { id } });
    },
    async getData() {
      const { data } = await getApplyRecored({
        openId: this.openId
      });
      console.log(data);
      this.recordList = data.list;
    }
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapState("user", ["openId"])
  }
};
</script>

<style lang="scss" scoped>
.application_record {
  padding: 0 20px;
  .list {
    .list_item {
      border-bottom: 4px solid #fff8e9;
      height: 99px;
      //   background-color: red;
      padding-top: 19px;
      .title {
        display: flex;
        justify-content: space-between;
        // background-color: greenyellow;
        height: 22px;
        line-height: 22px;
        opacity: 1;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: left;
        color: #543302;
        margin-bottom: 30px;
        span {
          opacity: 1;
          font-size: 16px;
          width: 80px;
          display: flex;
          justify-content: flex-end;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: left;
          color: #543302;
        }
      }
      .footer {
        // background-color: blue;
        display: flex;
        justify-content: space-between;
        height: 17px;
        opacity: 0.75;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: left;
        color: #543302;
        .right {
          &.no_pass {
            span {
              color: #ff0000;
              &:nth-child(1) {
                background-color: #ff0000;
              }
            }
          }
          &.pass {
            span {
              color: #62c663;
              &:nth-child(1) {
                background-color: #62c663;
              }
            }
          }
          span {
            opacity: 0.9;
            font-size: 12px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            text-align: left;
            color: #ffd63c;
            &:nth-child(1) {
              display: inline-block;
              width: 7px;
              height: 7px;
              background-color: #ffd63c;
              border-radius: 50%;
              vertical-align: middle;
              margin-right: 6px;
            }
          }
        }
      }
    }
  }
}
</style>
